/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Rooms Data
 */

// Icons
import {
    CgGift,
    CgScreen } from 'react-icons/cg';

import {
    MdAir,
    MdBalcony,
    MdBed,
    MdSingleBed,
    MdLandscape,
    MdHotTub,
    MdOutlineBathroom,
    MdOutlineLocalParking,
    MdOutlineSoap,
    MdPool,
    MdWeekend,
    MdWifi } from 'react-icons/md';

import roomGeleiaRealMain from '../assets/img/rooms/room-geleia-real-main.jpg'
import roomGeleiaRealMainWebp from '../assets/img/rooms/room-geleia-real-main.webp'
import roomGeleiaReal2 from '../assets/img/rooms/room-geleia-real-2.jpg'
import roomGeleiaReal2Webp from '../assets/img/rooms/room-geleia-real-2.webp'
import roomGeleiaReal3 from '../assets/img/rooms/room-geleia-real-3.jpg'
import roomGeleiaReal3Webp from '../assets/img/rooms/room-geleia-real-3.webp'
import roomMelMain from '../assets/img/rooms/room-mel-main.jpg'
import roomMelMainWebp from '../assets/img/rooms/room-mel-main.webp'
import roomMel2 from '../assets/img/rooms/room-mel-2.jpg'
import roomMel2Webp from '../assets/img/rooms/room-mel-2.webp'
import roomMel3 from '../assets/img/rooms/room-mel-3.jpg'
import roomMel3Webp from '../assets/img/rooms/room-mel-3.webp'
import roomPolenMain from '../assets/img/rooms/room-polen-main.jpg'
import roomPolenMainWebp from '../assets/img/rooms/room-polen-main.webp'
import roomPolen2 from '../assets/img/rooms/room-polen-2.jpg'
import roomPolen2Webp from '../assets/img/rooms/room-polen-2.webp'
import roomPolen3 from '../assets/img/rooms/room-polen-3.jpg'
import roomPolen3Webp from '../assets/img/rooms/room-polen-3.webp'
import roomPolen4 from '../assets/img/rooms/room-polen-4.jpg'
import roomPolen4Webp from '../assets/img/rooms/room-polen-4.webp'
import roomPropolisMain from '../assets/img/rooms/room-propolis-main.jpg'
import roomPropolisMainWebp from '../assets/img/rooms/room-propolis-main.webp'
import roomPropolis2 from '../assets/img/rooms/room-propolis-2.jpg'
import roomPropolis2Webp from '../assets/img/rooms/room-propolis-2.webp'
import roomPropolis3 from '../assets/img/rooms/room-propolis-3.jpg'
import roomPropolis3Webp from '../assets/img/rooms/room-propolis-3.webp'
import suiteMontanha1Main from '../assets/img/rooms/suite-montanha1-main.jpg'
import suiteMontanha1MainWebp from '../assets/img/rooms/suite-montanha1-main.webp'
import suiteMontanha12 from '../assets/img/rooms/suite-montanha1-2.jpg'
import suiteMontanha12Webp from '../assets/img/rooms/suite-montanha1-2.webp'
import suiteMontanha13 from '../assets/img/rooms/suite-montanha1-3.jpg'
import suiteMontanha13Webp from '../assets/img/rooms/suite-montanha1-3.webp'
import suiteMontanha14 from '../assets/img/rooms/suite-montanha1-4.jpg'
import suiteMontanha14Webp from '../assets/img/rooms/suite-montanha1-4.webp'
import suiteMontanha15 from '../assets/img/rooms/suite-montanha1-5.jpg'
import suiteMontanha15Webp from '../assets/img/rooms/suite-montanha1-5.webp'
import suiteMontanha16 from '../assets/img/rooms/suite-montanha1-6.jpg'
import suiteMontanha16Webp from '../assets/img/rooms/suite-montanha1-6.webp'
import suiteMontanha2Main from '../assets/img/rooms/suite-montanha2-main.jpg'
import suiteMontanha2MainWebp from '../assets/img/rooms/suite-montanha2-main.webp'
import suiteMontanha22 from '../assets/img/rooms/suite-montanha2-2.jpg'
import suiteMontanha22Webp from '../assets/img/rooms/suite-montanha2-2.webp'
import suiteMontanha23 from '../assets/img/rooms/suite-montanha2-3.jpg'
import suiteMontanha23Webp from '../assets/img/rooms/suite-montanha2-3.webp'
import suiteMontanha24 from '../assets/img/rooms/suite-montanha2-4.jpg'
import suiteMontanha24Webp from '../assets/img/rooms/suite-montanha2-4.webp'

const facilities = {
    kingSizeBed: {
        icon: (<MdBed />),
        text: 'Cama king size'
    },
    queenSizeBed: {
        icon: (<MdBed />),
        text: 'Cama queen size'
    },
    extraBed: {
        icon: (<MdSingleBed />),
        text: 'Possibilidade de cama extra'
    },
    extraSofa: {
        icon: (<MdWeekend />),
        text: 'Sofá-cama'
    },
    privateBathroom: {
        icon: (<MdOutlineBathroom />),
        text: 'Casa de banho privativa'
    },
    ac: {
        icon: (<MdAir />),
        text: 'Ar condicionado'
    },
    wifi: {
        icon: (<MdWifi />),
        text: 'Wi-fi'
    },
    tv: {
        icon: (<CgScreen />),
        text: 'TV'
    },
    welcomePresent: {
        icon: (<CgGift />),
        text: 'Presente de boas vindas'
    },
    mountainView: {
        icon: (<MdLandscape />),
        text: 'Vista para a montanha'
    },
    jacuzzi: {
        icon: (<MdHotTub />),
        text: 'Jacuzzi'
    },
    parking: {
        icon: (<MdOutlineLocalParking />),
        text: 'Estacionamento'
    },
    swimmingPool: {
        icon: (<MdPool />),
        text: 'Piscina'
    },
    balcony: {
        icon: (<MdBalcony />),
        text: 'Varanda'
    },
    amenities: {
        icon: (<MdOutlineSoap />),
        text: 'Amenities: sabonete e champô de mel'
    }
}

export const ROOMS = [
    {
        id: 0,
        title: 'Quarto Mel',
        text: 'Deixe-se envolver pela doçura e desfrute do conforto e harmonia deste espaço.',
        src: roomMelMain,
        srcWebp: roomMelMainWebp,
        price: {
          value: '€85',
          sup: '.00',
          per: '/Noite'
        },
        mainFacilities: [
            [
                (facilities.queenSizeBed),
                (facilities.extraBed),
                (facilities.privateBathroom)
            ],[
                (facilities.wifi),
                (facilities.tv),
                (facilities.welcomePresent)
            ]
        ],
        facilities: [
            [
                (facilities.queenSizeBed),
                (facilities.extraBed),
                (facilities.privateBathroom),
                (facilities.amenities),
                (facilities.ac),
            ],[
                (facilities.wifi),
                (facilities.tv),
                (facilities.parking),
                (facilities.swimmingPool),
                (facilities.welcomePresent)
            ]
        ],
        images :[
            {
                id: 0,
                src: roomMelMain,
                srcWebp: roomMelMainWebp,
                altText: "Quarto Mel"
            },
            {
                id: 1,
                src: roomMel2,
                srcWebp: roomMel2Webp,
                altText: "Quarto Mel"
            },
            {
                id: 2,
                src: roomMel3,
                srcWebp: roomMel3Webp,
                altText: "Quarto Mel"
            },
        ]
    },
    {
        id: 1,
        title: 'Quarto Própolis',
        text: 'Surpreenda-se com a autenticidade e simplicidade dos elementos naturais e usufrua deste refugio de paz e bem-estar.',
        src: roomPropolisMain,
        srcWebp: roomPropolisMainWebp,
        price: {
          value: '€85',
          sup: '.00',
          per: '/Noite'
        },
        mainFacilities: [
            [
                (facilities.queenSizeBed),
                (facilities.privateBathroom),
                (facilities.mountainView)
            ],[
                (facilities.wifi),
                (facilities.tv),
                (facilities.welcomePresent)
            ]
        ],
        facilities: [            
            [
                (facilities.queenSizeBed),
                (facilities.privateBathroom),
                (facilities.amenities),
                (facilities.ac),
                (facilities.mountainView),
            ],[
                (facilities.wifi),
                (facilities.tv),
                (facilities.parking),
                (facilities.swimmingPool),
                (facilities.welcomePresent)
            ]
        ],
        images :[
            {
                id: 0,
                src: roomPropolisMain,
                srcWebp: roomPropolisMainWebp,
                altText: "Quarto Própolis"
            },
            {
                id: 1,
                src: roomPropolis2,
                srcWebp: roomPropolis2Webp,
                altText: "Quarto Própolis"
            },
            {
                id: 2,
                src: roomPropolis3,
                srcWebp: roomPropolis3Webp,
                altText: "Quarto Própolis"
            },
        ]
    },
    {
        id: 2,
        title: 'Quarto Geleia Real',
        text: 'De dimensões generosas, e inspirado no estilo vitoriano, este quarto foi pensado para lhe proporcionar uma estadia digna de realeza.',
        src: roomGeleiaRealMain,
        srcWebp: roomGeleiaRealMainWebp,
        price: {
          value: '€95',
          sup: '.00',
          per: '/Noite'
        },
        mainFacilities: [
            [
                (facilities.kingSizeBed),
                (facilities.privateBathroom),
                (facilities.mountainView)
            ],[
                (facilities.wifi),
                (facilities.extraSofa),
                (facilities.welcomePresent)
            ]
        ],
        facilities: [
            [
                (facilities.kingSizeBed),
                (facilities.extraSofa),
                (facilities.privateBathroom),
                (facilities.amenities),
                (facilities.ac),
                (facilities.mountainView)
            ],[
                (facilities.wifi),
                (facilities.tv),
                (facilities.parking),
                (facilities.swimmingPool),
                (facilities.welcomePresent)
            ]
        ],
        images :[
            {
                id: 0,
                src: roomGeleiaRealMain,
                srcWebp: roomGeleiaRealMainWebp,
                altText: "Quarto Geleia Real"
            },
            {
                id: 1,
                src: roomGeleiaReal2,
                srcWebp: roomGeleiaReal2Webp,
                altText: "Quarto Geleia Real"
            },
            {
                id: 2,
                src: roomGeleiaReal3,
                srcWebp: roomGeleiaReal3Webp,
                altText: "Quarto Geleia Real"
            }
        ]
    },
    {
        id: 3,
        title: 'Quarto Pólen',
        text: 'Imagine-se num campo com flores, relaxe ao som do zumbido das abelhas, sinta a magia e desfrute do aconchego deste espaço.',
        src: roomPolenMain,
        srcWebp: roomPolenMainWebp,
        price: {
          value: '€85',
          sup: '.00',
          per: '/Noite'
        },
        mainFacilities: [
            [
                (facilities.queenSizeBed),
                (facilities.extraBed),
                (facilities.privateBathroom)
            ],[
                (facilities.wifi),
                (facilities.tv),
                (facilities.welcomePresent)
            ]
        ],
        facilities: [
            [
                (facilities.queenSizeBed),
                (facilities.extraBed),
                (facilities.privateBathroom),
                (facilities.amenities),
                (facilities.ac)
            ],[
                (facilities.wifi),
                (facilities.tv),
                (facilities.parking),
                (facilities.swimmingPool),
                (facilities.welcomePresent)
            ]
        ],
        images :[
            {
                id: 0,
                src: roomPolenMain,
                srcWebp: roomPolenMainWebp,
                altText: "Quarto Pólen"
            },
            {
                id: 1,
                src: roomPolen2,
                srcWebp: roomPolen2Webp,
                altText: "Quarto Pólen"
            },
            {
                id: 1,
                src: roomPolen3,
                srcWebp: roomPolen3Webp,
                altText: "Quarto Pólen"
            },
            {
                id: 1,
                src: roomPolen4,
                srcWebp: roomPolen4Webp,
                altText: "Quarto Pólen"
            }
        ]
    },
    {
        id: 4,
        title: 'Suite Montanha 1',
        text: 'Entre e sinta o abraço das montanhas, dirija-se à varanda e inspire o ar mais puro. Desfrute de uma bebida num spa com água quente e deslumbre-se com uma vista de 360º sobre as montanhas.',
        src: suiteMontanha1Main,
        srcWebp: suiteMontanha1MainWebp,
        price: {
          value: '€125',
          sup: '.00',
          per: '/Noite'
        },
        mainFacilities: [
            [
                (facilities.queenSizeBed),
                (facilities.balcony),
                (facilities.mountainView)
            ],[
                (facilities.wifi),
                (facilities.jacuzzi),
                (facilities.welcomePresent)
            ]
        ],
        facilities: [
            [
                (facilities.queenSizeBed),
                (facilities.privateBathroom),
                (facilities.amenities),
                (facilities.ac),
                (facilities.balcony),
                (facilities.mountainView)
            ],[
                (facilities.jacuzzi),
                (facilities.wifi),
                (facilities.tv),
                (facilities.parking),
                (facilities.swimmingPool),
                (facilities.welcomePresent)
            ]
        ],
        images :[
            {
                id: 0,
                src: suiteMontanha1Main,
                srcWebp: suiteMontanha1MainWebp,
                altText: "Suite Montanha 1"
            },
            {
                id: 1,
                src: suiteMontanha12,
                srcWebp: suiteMontanha12Webp,
                altText: "Suite Montanha 1"
            },
            {
                id: 2,
                src: suiteMontanha13,
                srcWebp: suiteMontanha13Webp,
                altText: "Suite Montanha 1"
            },
            {
                id: 3,
                src: suiteMontanha14,
                srcWebp: suiteMontanha14Webp,
                altText: "Suite Montanha 1"
            },
            {
                id: 4,
                src: suiteMontanha15,
                srcWebp: suiteMontanha15Webp,
                altText: "Suite Montanha 1"
            },
            {
                id: 5,
                src: suiteMontanha16,
                srcWebp: suiteMontanha16Webp,
                altText: "Suite Montanha 1"
            },            
        ]
    },
    {
        id: 5,
        title: 'Suite Montanha 2',
        text: 'Com uma vista deslumbrante para as montanhas e povoação da vila do Caramulo, é o refugio perfeito para desconectar-se da rotina diária.',
        src: suiteMontanha2Main,
        // srcWebp: suiteMontanha2MainWebp,
        price: {
          value: '€105',
          sup: '.00',
          per: '/Noite'
        },
        mainFacilities: [
            [
                (facilities.queenSizeBed),
                (facilities.balcony),
                (facilities.mountainView)
            ],[
                (facilities.wifi),
                (facilities.tv),
                (facilities.welcomePresent)
            ]
        ],
        facilities: [
            [
                (facilities.queenSizeBed),
                (facilities.privateBathroom),
                (facilities.amenities),
                (facilities.ac),
                (facilities.balcony),
                (facilities.mountainView)
            ],[
                (facilities.wifi),
                (facilities.tv),
                (facilities.parking),
                (facilities.swimmingPool),
                (facilities.welcomePresent)
            ]
        ],
        images :[
            {
                id: 0,
                src: suiteMontanha2Main,
                srcWebp: suiteMontanha2MainWebp,
                altText: "Suite Montanha 2"
            },
            {
                id: 1,
                src: suiteMontanha22,
                srcWebp: suiteMontanha22Webp,
                altText: "Suite Montanha 2"
            },
            {
                id: 2,
                src: suiteMontanha23,
                srcWebp: suiteMontanha23Webp,
                altText: "Suite Montanha 2"
            },
            {
                id: 3,
                src: suiteMontanha24,
                srcWebp: suiteMontanha24Webp,
                altText: "Suite Montanha 2"
            },
        ]
    }
]